import { render, staticRenderFns } from "./FileAttachmentSlimWidget.view.vue?vue&type=template&id=4c1c6061&"
import script from "./FileAttachmentSlimWidget.view.vue?vue&type=script&lang=js&"
export * from "./FileAttachmentSlimWidget.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1c6061')) {
      api.createRecord('4c1c6061', component.options)
    } else {
      api.reload('4c1c6061', component.options)
    }
    module.hot.accept("./FileAttachmentSlimWidget.view.vue?vue&type=template&id=4c1c6061&", function () {
      api.rerender('4c1c6061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/sign/partials/FileAttachmentSlimWidget.view.vue"
export default component.exports